module.exports = __webpack_public_path__ + "static/media/save_icon.2936b3e1.svg";